import React, { useEffect, useState } from "react";

function Counter({ end, duration, prefix = "", suffix = "" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const fps = 60; // frames per second
    const totalFrames = duration * fps;
    const increment = end / totalFrames;
    let frame = 0;

    const step = () => {
      frame++;
      start += increment;
      if (frame < totalFrames) {
        setCount(start);
        requestAnimationFrame(step);
      } else {
        setCount(end); // ensure exact end value
      }
    };

    requestAnimationFrame(step);
  }, [end, duration]);

  return (
    <span>
      {prefix}
      {Number.isInteger(end) ? Math.round(count) : count.toFixed(1)}
      {suffix}
    </span>
  );
}

function Counters() {
  return (
    <section className="funfact-section">
      <div
        className="bg_layer"
        style={{
          backgroundImage: "url(/images/background/funfact_shape_bg.png)",
        }}
      ></div>
      <div className="container">
        <div className="row">
          {/* Counter 1 */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="funfact-block-one">
              <div className="count-outer count-box">
                <Counter end={2.5} duration={2.5} prefix="₹" suffix="B" />
              </div>
              <h6>Assets Managed</h6>
            </div>
          </div>

          {/* Counter 2 */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="funfact-block-one">
              <div className="count-outer count-box">
                <Counter end={15} duration={2.5} suffix="%+" />
              </div>
              <h6>Avg. Returns</h6>
            </div>
          </div>

          {/* Counter 3 */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="funfact-block-one">
              <div className="count-outer count-box">
                <Counter end={5} duration={2.5} suffix="%" />
              </div>
              <h6>Investors</h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Counters;
